import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import numeral from "numeral";
import "numeral/locales/pt-br";
import React, { useState } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "typeface-roboto";
import { authLogin, authLogout, orcamentoId, pipedriveDealId } from "./actions";
import AuthContext from "./context/auth-context";
import AceitePagina from "./pages/Aceite";
import AuthPage from "./pages/Auth";
import CancelarPagina from "./pages/Cancelar";
import InicioPagina from "./pages/Home";
import OrcamentoPagina from "./pages/Orcamento";
import { store } from "./store";

toast.configure();
numeral.locale("pt-br");

const App = (props) => {
	const theme = createMuiTheme({
		palette: {
			primary: {
				main: "#2a8590",
			},
		},
	});

	const [token, setToken] = useState(store.getState().authReducer.userToken);
	const [userId, setUserId] = useState(store.getState().authReducer.userId);

	const login = (loginData) => {
		setToken(loginData.token);
		setUserId(loginData.userId);
		store.dispatch(authLogin(loginData));
	};

	const setPipedriveDealId = (data) => {
		store.dispatch(pipedriveDealId(data.pipedriveDealId));
	};

	const setOrcamentoId = (data) => {
		store.dispatch(orcamentoId(data.orcamentoId));
	};

	const logout = () => {
		setToken(null);
		store.dispatch(authLogout());
	};

	return (
		<ThemeProvider theme={theme}>
			<AuthContext.Provider
				value={{
					token: token,
					userId: userId,
					login: login,
					logout: logout,
					setPipedriveDealId: setPipedriveDealId,
					setOrcamentoId: setOrcamentoId,
				}}
			>
				<div className="app">
					<BrowserRouter>
						<Switch>
							<Route exact path="/auth" component={AuthPage} />
							{token && (
								<React.Fragment>
									<div className="app__container">
										<div className="page__container">
											<Route exact path="/" component={InicioPagina} />
											<Route exact path="/dashboard" component={InicioPagina} />
											<Route
												exact
												path="/orcamento/criar"
												component={OrcamentoPagina}
											/>
											<Route
												exact
												path="/orcamento/aceite"
												component={AceitePagina}
											/>
											<Route
												exact
												path="/orcamento/cancelar"
												component={CancelarPagina}
											/>
										</div>
									</div>
								</React.Fragment>
							)}

							{!token && <Redirect to="/auth" exact />}
						</Switch>
					</BrowserRouter>
				</div>
			</AuthContext.Provider>
		</ThemeProvider>
	);
};
export default App;
